module.exports = __webpack_public_path__ + "static/media/slideMobile01.6749faca.jpg";